export default __webpack_public_path__ + "static/media/image15.b512b877.png";